import { ResponseTransformer } from '../ResponseTransformer';
import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/hero-saga/equipments';
import { camelizeKeys } from '~/utils/helpers';
import { titleCase } from '~/utils/helpers';

const equipmentApi = {
    index: async () => {
        const { data } = await http.get(`${API_PREFIX}`);

        return camelizeKeys(data);
    },

    create: async () => {
        let { data } = await http.get(`${API_PREFIX}/create`);

        data = new ResponseTransformer(data);
        data.camelizeKeys();
        data.transformEquipmentCategories();

        return data;
    },

    store: async (body) => {
        await http.post(`${API_PREFIX}`, body, {});
    },

    show: async (id) => {
        let { data } = await http.get(`${API_PREFIX}/${id}`);

        data = new ResponseTransformer(data);
        data.camelizeKeys();
        data.transformEquipmentCategories();
        data.transformDurabilitiesPerEquipment();

        return data;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

//**Interface Segregation Principle (https://www.youtube.com/watch?v=JVWZR23B_iE&list=PLZlA0Gpn_vH9kocFX7R7BAe_CvvOCO_p9&index=4)
const transformEquipmentCategories = {
    transformEquipmentCategories() {
        this.data.equipmentCategories.forEach(function (category, i, arr) {
            arr[i] = {
                id: category,
                name: titleCase(category),
            };
        });
    },
};
const transformDurabilitiesPerEquipment = {
    transformDurabilitiesPerEquipment() {
        this.data.model.durabilities.forEach(function (item, i, arr) {
            arr[i] = item.id;
        });
    },
};
Object.assign(ResponseTransformer.prototype, transformEquipmentCategories);
Object.assign(ResponseTransformer.prototype, transformDurabilitiesPerEquipment);

export default equipmentApi;
